import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { applyStoredConsent, trackPageView } from '@/lib/analytics';

/**
 * Re-applies stored consent on mount (returning visitors don't need to
 * re-accept) and fires page_view on client-side route changes. The first
 * page_view is sent by gtag's auto-page-view from index.html, so this
 * effect skips its first tick to avoid a duplicate hit.
 *
 * Must be rendered inside <BrowserRouter>.
 */
export function AnalyticsProvider() {
  const location = useLocation();
  const firstRouteHandled = useRef(false);

  useEffect(() => {
    applyStoredConsent();
  }, []);

  useEffect(() => {
    if (!firstRouteHandled.current) {
      firstRouteHandled.current = true;
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
